// features/projects/templates/continuum/tokens.js
// ═══════════════════════════════════════════════════════════
// CONTINUUM DESIGN TOKENS — kept VERBATIM from the source HTML
// mockups (continuum_simulation.html + signal_dashboard.html).
//
// Per Tims rule for templated projects: do NOT normalize these
// to Shift's standard design tokens, even when the values overlap.
// The mockup is the contract — small variations (e.g. teal #5a9eb5
// here vs Shifts --teal #4db8b8) are intentional.
//
// Shared by every sub-tab inside templates/continuum/.
// ═══════════════════════════════════════════════════════════

export const C = {
  // Surfaces
  bg:    '#07070a',
  s1:    '#0c0c11',
  s2:    '#111118',

  // Borders
  b1:    '#1e1e2a',
  b2:    '#272736',
  b3:    '#363650',

  // Text
  text:  '#f0eefa',
  mid:   '#c8c4e0',
  static:'#888888',
  dim:   '#555566',

  // Accents
  gold:  '#c8a96e',
  sage:  '#7a9e82',
  teal:  '#5a9eb5',
  terra: '#c46050',
  purple:'#9b8fc4',
  amber: '#d4956a',
};

export const FONT = {
  mono:  "'DM Mono', monospace",
  sans:  "'DM Sans', sans-serif",
  serif: "'Cormorant Garamond', serif",
};

// ─── Signal palette ─────────────────────────────────────
// Used by the Dashboard tab. Verbatim from signal_dashboard.html.
// DIFFERENT from the Continuum cool palette above — Signal is the
// "field/conservation" view (green-tinted) where C is the
// "research/data" view (neutral-cool). The contrast between tabs
// is intentional per the source mockups.
export const S = {
  bg:    '#07100a',
  s1:    '#0c1610',
  s2:    '#111d14',
  s3:    '#162019',
  b1:    '#1e2e21',
  b2:    '#263428',
  b3:    '#344038',

  forest:'#4a8c5c',
  water: '#3d8a7a',
  amber: '#c8943e',
  terra: '#c45040',
  sage:  '#7a9e82',
  gold:  '#c8a96e',

  text:  '#e8ede9',
  mid:   '#b8c8bb',
  static:'#7a907e',
  dim:   '#4a5e4d',
};

// Signal uses Playfair Display for headlines instead of Cormorant.
export const SIGNAL_FONT = {
  mono:  "'DM Mono', monospace",
  sans:  "'DM Sans', sans-serif",
  serif: "'Playfair Display', serif",
};
